export const ASLoginUrl =
  "https://www.alaskaair.com/www2/ssl/myalaskaair/MyAlaskaAir.aspx?CurrentForm=UCSignInStart&url=https://www.alaskaair.com";

//----------------- Mileage Activity UI Component Constants -----------------
export const ActivityHeaders = [
  "Date",
  "Activity",
  "Status",
  "Points",
  "Bonus Points",
  "Total Points",
  "Status Points",
];
export const ActivitiesTableHeaders = [
  { header: "Date", accessor: (row: any) => row.Date },
  { header: "Activity", accessor: (row: any) => row.PartnerName },
  { header: "Status", accessor: (row: any) => (row.EligibilityReason ? "Declined" : row.Status) },
  { header: "Points", accessor: (row: any) => Number(row.Miles).toLocaleString() },
  { header: "Bonus Points", accessor: (row: any) => Number(row["Bonus Miles"]).toLocaleString() },
  { header: "Total Points", accessor: (row: any) => Number(row["Total Miles"]).toLocaleString() },
  { header: "Status Points", accessor: (row: any) => row["Status Points"] || "0" },
];
